/**
 * RBAC helpers — wildcard-aware permission matching.
 *
 * Mirrors the v1 logic so JWTs minted by admin_service still authorise
 * the same way. Patterns supported:
 *   - exact match:        "crm.read" ⊆ ["crm.read", "logs.read"]
 *   - global wildcard:    "*" matches anything
 *   - namespace wildcard: "crm.*" matches "crm.read", "crm.write", etc.
 */

export function hasPerm(claims: readonly string[], required: string): boolean {
  if (!required) return true
  for (const p of claims) {
    if (p === '*') return true
    if (p === required) return true
    if (p.endsWith('.*') && required.startsWith(p.slice(0, -1))) return true
  }
  return false
}

export function hasAnyPerm(claims: readonly string[], required: readonly string[]): boolean {
  return required.some((p) => hasPerm(claims, p))
}

export function hasAllPerms(claims: readonly string[], required: readonly string[]): boolean {
  return required.every((p) => hasPerm(claims, p))
}

export function hasRole(roles: readonly string[], required: string): boolean {
  return roles.includes(required)
}
